import React from 'react';
import PropTypes from 'prop-types';

import { LITTER_STATES } from 'dpl/shared/constants/shared';
import Icon from 'dpl/common/components/Icon';
import { getLitterStatusIconName } from 'dpl/shared/utils/breeder_app';
import SmartImage from 'dpl/components/SmartImage';

const ICON_SIZE = '56px';

export function BreederProfileLitterIcon({
  coverPhotoUrl,
  status,
  height,
  width
}) {
  if (coverPhotoUrl) {
    return (
      <SmartImage
        Tag="div"
        src={coverPhotoUrl}
        className="bg-center cover br3"
        width={height}
        height={width}
      />
    );
  }

  return (
    <div
      className="pv4 ph4 inline-flex items-center justify-center bg-light-purple br3"
      style={{ width, height }}
    >
      <Icon
        className="purple"
        name={getLitterStatusIconName(status)}
        width="24px"
        height="24px"
      />
    </div>
  );
}

BreederProfileLitterIcon.propTypes = {
  coverPhotoUrl: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  status: PropTypes.oneOf([
    LITTER_STATES.BORN,
    LITTER_STATES.PLANNED,
    LITTER_STATES.EXPECTED
  ]).isRequired
};

BreederProfileLitterIcon.defaultProps = {
  coverPhotoUrl: null,
  height: ICON_SIZE,
  width: ICON_SIZE
};
